import React from 'react';
import { Link } from 'react-router-dom';
import "./error.css";


const Error404 = () => {
  return (
    <div className=" min-h-screen flex items-center">
            {/*  404 Error Text */}
        <div className="text-center">
            <div className="error mx-auto font-semibold" data-text="404">404</div>
            <p className=" text-white text-sm mb-5">Page Not Found</p>
            <p className="text-white text-xs sm:text-sm mb-4">It looks like you found a glitch in the matrix...</p>
            <Link to="" className='rounded-md text-xs bg-zinc-700 text-white px-4 py-2 shadow-md '>&larr; Back to Home</Link>
        </div>
    </div>
  )
}

export default Error404;